import { useEffect, useRef, useState } from "react"

const useCountDown = ({initialValue, tickInSeconds, onCountdownComplete, startCountDown = true}: {initialValue: number, tickInSeconds: number, onCountdownComplete?: () => void, startCountDown?: boolean}) => {
    const [timer, setTimer] = useState<number>(initialValue);
    const timeoutRef = useRef<number>(0);

    function cleanUp() {
        if (timeoutRef.current) {
            clearInterval(timeoutRef.current);
            timeoutRef.current = null;
        }
    }

    useEffect(() => {
        if(!startCountDown) {
            return() => {
                cleanUp()
            }
        }

        if (timeoutRef.current) {
            clearInterval(timeoutRef.current);
        }

        if (timer <= 0) {
            onCountdownComplete?.();
            return () => {
                cleanUp()
            }
        }

        
        timeoutRef.current = setTimeout(() => {
            setTimer(timer - 1);
            
        }, tickInSeconds * 1000)

        return () => {
            cleanUp()
        }

    }, [timer, startCountDown])

    useEffect(() => {
        setTimer(initialValue)
    }, [initialValue])

    

    return timer;
}

export default useCountDown
